import React, { useState, useEffect } from 'react'
import ParentsMainHeader from '../../components/MainHeader/ParentsMainHeader'
import parentprofileStyle from './ParentsProfilePage.module.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';
import { useParams, useNavigate } from "react-router-dom";

export default function ParentsProfilePage() {

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    // Password Eyes
    const [isPasswordVisible, setPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!isPasswordVisible);
    };

    // Confirm Password Eyes
    const [isCPasswordVisible, setCPasswordVisible] = useState(false);

    const toggleCPasswordVisibility = () => {
        setCPasswordVisible(!isCPasswordVisible);
    };

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [position, setPosition] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const { id } = useParams();

    useEffect(() => {
        //const userId = 123; // replace with actual logged-in user's ID
        fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_parent_profile.php?user_id=${id}`)
            .then(res => res.json())
            .then(data => {
                // Fill state with data
                setFirstName(data.first_name);
                setLastName(data.last_name);
                setEmail(data.user_email);
                setPhone(data.user_phone);
                setPosition(data.position);
                setImagePreviewUrl(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/${data.image_path}`);
            });
    }, []);

    const handleSave = () => {
        if (password !== confirmPassword) {
            alert("Passwords do not match");
            return;
        }

        const userId = id; // Replace with actual user ID from session/context
        const formData = new FormData();

        formData.append('user_id', userId);
        formData.append('firstName', firstName);
        formData.append('lastName', lastName);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('position', position);
        formData.append('password', password);
        if (imageFile) {
            formData.append('image', imageFile);
        }

        fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/update_parent_profile.php`, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                alert(data.message);
            });
    };

    const handlePhoneChange = (e) => {
        const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
        setPhone(digitsOnly); // store only numbers
    };

    const formatPhone = (value) => {
        if (!value) return "";

        const digits = value.replace(/\D/g, "").slice(0, 10);

        if (digits.length <= 3) return digits;
        if (digits.length <= 6)
            return `${digits.slice(0, 3)}-${digits.slice(3)}`;

        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setImagePreviewUrl(reader.result);
            reader.readAsDataURL(file);
        }
    };

    return (
        <>
            <ParentsMainHeader />
            {isMobile ? (
                <div className={parentprofileStyle.mobilparentprofilepage}>
                    <div className="container h-100">
                        <div className="row justify-content-center h-100 align-items-start">
                            <div className="col-xl-12 col-xxl-12">
                                <h3> Account Profile </h3>
                                <div className={parentprofileStyle.mobilparentContent}>
                                    <div className="row g-2 mb-3">
                                        <div className='row g-0'>
                                            <div className="col-3">
                                                <div className={parentprofileStyle.mobilparentproimageCircle}>
                                                    <div className={parentprofileStyle.mobilparentprocircleEdit}>
                                                        <input type='file' id="mobilpublisherimageUploads" className={parentprofileStyle.mobilparentproInputcircle} accept=".png, .jpg, .jpeg" />
                                                        <label for="mobilpublisherimageUploads"></label>
                                                    </div>
                                                    <div className={parentprofileStyle.mobilparentprocirclePreview}>
                                                        <div id="publisherimagePreview"> </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <label className={`${parentprofileStyle.mobilparentproLabel} form-label`}> First Name </label>
                                            <input type="text" className={`${parentprofileStyle.mobilparentproInput} form-control`} required />
                                        </div>
                                        <div className="col-6">
                                            <label className={`${parentprofileStyle.mobilparentproLabel} form-label`}> Last Name </label>
                                            <input type="text" className={`${parentprofileStyle.mobilparentproInput} form-control`} required />
                                        </div>
                                        <div className="col-12">
                                            <label className={`${parentprofileStyle.mobilparentproLabel} form-label`}> Email Address </label>
                                            <input type="email" className={`${parentprofileStyle.mobilparentproInput} form-control`} required />
                                        </div>
                                        <div className="col-12">
                                            <label className={`${parentprofileStyle.mobilparentproLabel} form-label`}> Phone Number </label>
                                            <input type="number" className={`${parentprofileStyle.mobilparentproInput} form-control`} required />
                                        </div>
                                        <div className="col-12 mt-4">
                                            <hr />
                                        </div>
                                        <div className="col-12">
                                            <label className={`${parentprofileStyle.mobilparentproLabel} form-label`}> Password </label>
                                            <div className={parentprofileStyle.parentpropasswordwrapper}>
                                                <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${parentprofileStyle.mobilparentproInput} form-control`} required />
                                                <div className={parentprofileStyle.parentprotogglebutton} onClick={togglePasswordVisibility}>
                                                    {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <label className={`${parentprofileStyle.mobilparentproLabel} form-label`}> Confirm your password </label>
                                            <div className={parentprofileStyle.parentpropasswordwrapper}>
                                                <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${parentprofileStyle.mobilparentproInput} form-control`} required />
                                                <div className={parentprofileStyle.parentprotogglebutton} onClick={toggleCPasswordVisibility}>
                                                    {isCPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="text-center mb-4">
                                        <button className={`${parentprofileStyle.mobilparentprosaveButton} btn btn-primary w-100`}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={parentprofileStyle.parentprofilepage}>
                    <div className="container h-100">
                        <div className="row justify-content-center h-100 align-items-start">
                            <div className="col-xl-9 col-xxl-9">
                                <h3> Account Profile </h3>
                                <div className={parentprofileStyle.parentprofileContent}>
                                    <div className="row mb-3 justify-content-center">
                                        <div className="col-xl-9 col-xxl-9">
                                            <h6> Publisher Information </h6>
                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <label className={`${parentprofileStyle.parentproLabel} form-label`}>First Name</label>
                                                    <input type="text" className={`${parentprofileStyle.parentproInput} form-control`} value={firstName} onChange={e => setFirstName(e.target.value)} required />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className={`${parentprofileStyle.parentproLabel} form-label`}>Last Name</label>
                                                    <input type="text" className={`${parentprofileStyle.parentproInput} form-control`} value={lastName} onChange={e => setLastName(e.target.value)} required />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <label className={`${parentprofileStyle.parentproLabel} form-label`}>Email Address</label>
                                                    <input type="email" className={`${parentprofileStyle.parentproInput} form-control`} value={email} onChange={e => setEmail(e.target.value)} required />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <label className={`${parentprofileStyle.parentproLabel} form-label`}>Phone:</label>
                                                    <input type="text" className={`${parentprofileStyle.parentproInput} form-control`} value={formatPhone(phone)} onChange={handlePhoneChange} maxLength={12} inputMode="numeric" required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-xxl-3">
                                            <div className={parentprofileStyle.parentproimageCircle}>
                                                <div className={parentprofileStyle.parentprocircleEdit}>
                                                    <input type='file' id="parentimageUploads" className={parentprofileStyle.parentproInputcircle} accept=".png, .jpg, .jpeg" onChange={handleImageChange} />
                                                    <label for="parentimageUploads"></label>
                                                </div>
                                                <div className={parentprofileStyle.parentprocirclePreview}>
                                                    <div id="publisherimagePreview">
                                                        {imagePreviewUrl && <img src={imagePreviewUrl} alt="preview" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />}</div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-xl-9 col-xxl-9">
                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <label className={`${parentprofileStyle.parentproLabel} form-label`}>Username</label>
                                                    <input type="text" className={`${parentprofileStyle.parentproInput} form-control`} required />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="mb-3">
                                                    <label className={`${parentprofileStyle.parentproLabel} form-label`}> Choose your password </label>
                                                    <div className={parentprofileStyle.parentspropasswordwrapper}>
                                                        <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${parentprofileStyle.parentproInput} form-control`} value={password}
                                                            onChange={e => setPassword(e.target.value)} required />
                                                        <div className={parentprofileStyle.parentsprotogglebutton} onClick={togglePasswordVisibility}>
                                                            {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="mb-3">
                                                    <label className={`${parentprofileStyle.parentproLabel} form-label`}> Confirm your password </label>
                                                    <div className={parentprofileStyle.parentspropasswordwrapper}>
                                                        <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${parentprofileStyle.parentproInput} form-control`} value={confirmPassword}
                                                            onChange={e => setConfirmPassword(e.target.value)} required />
                                                        <div className={parentprofileStyle.parentsprotogglebutton} onClick={toggleCPasswordVisibility}>
                                                            {isCPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-xxl-3"></div>
                                    </div>
                                    <div className="row">
                                        <div className="text-center mb-3 mt-4">
                                            <button className={`${parentprofileStyle.parentsprosaveButton} btn btn-warning `} onClick={handleSave} >Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}
